module.exports = __webpack_public_path__ + "static/media/Magstand-Plus-Logo.0e3b3b4e.png";